export const routes = {
  login: "/",
  dashboard: "/dashboard",
  organisationManagement: "/organisation-management",
  userManagement: "/user-management"
};
